import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  ButtonItem,
  ErrorItem,
  RangePickerItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
import dayjs from "dayjs";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteInsumosNoInventariables extends Component {
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasInventario: [],
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                ) +
                  " - " +
                  value.nombre}
              </Option>
            )),
          });
        }
      });
    this.consultarReporte({
      periodo: [moment().subtract(1, "month"), moment()],
    });
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeInventario/reporteInsumosNoInventariables",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasInventario: res.data.movimientos,
          });
        } else {
          message.error("Ha sucedido un error y no se cargó bien el reporte");
          this.setState({ loading: false });
        }
      });
  }

  buildExcelRows(movimientos) {
    const toNum2 = (v) =>
      Number(
        (v ?? 0).toFixed
          ? (v ?? 0).toFixed(2)
          : (Math.round((v ?? 0) * 100) / 100).toFixed(2)
      );
    const parseFecha = (val) => {
      if (!val) return "—";
      const d = dayjs(val);
      return d.isValid() ? new Date(Date.UTC(d.year(), d.month(), d.date(), 12, 0, 0)) : "—";
    };
    return movimientos.map((v) => ({
      Fecha: parseFecha(v.createdAt),
      "Folio Movimiento": v.folioMovimiento ?? "—",
      "Folio Movimiento Tipo": v.folioMovimientoTipo ?? "—",
      "Tipo Documento": v.tipoDocumento ?? "—",
      "Folio Documento": v.folioDocumento ?? "—",
      "Cód. Proveedor": v.codigoProveedor ?? "—",
      "Cliente / Proveedor": v.clienteProveedor ?? "—",
      Clave: v.claveInsumo,
      Descripción: v.descripcionInsumo,
      Familia: v.nombreFamilia,
      "Proyecto": v.proyectoNombre ?? "—",
      "Proyecto Origen": v.proyectoOrigenNombre ?? "—",
      "Proyecto Destino": v.proyectoDestinoNombre ?? "—",
      Unidad: v.nombreUnidad,
      "Costo Moneda Compra": v.costoMonedaDeCompra ?? "—",
      "Moneda Compra": v.monedaDeCompraClave ?? "—",
      "Costo Unitario": toNum2(v.costoUnitario),
      Cantidad: toNum2(v.cantidad),
      "Costo Total": toNum2(v.costoTotal),
      Lote: v.lote ?? "—",
      Caducidad: parseFecha(v.caducidad),
      Referencia: v.referencia ?? "—",
      Observaciones: v.observaciones ?? "—",
      Concepto: v.concepto,
      Responsable: v.nombreUsuario,
      "Hora Recibido": v.horaRecibido ? dayjs(v.horaRecibido).format("DD/MM/YYYY HH:mm") : "—",
    }));
  }

  descargarExcelEntradas() {
    const entradas = this.state.todasInventario.filter((v) => !v.salida);
    if (!entradas.length) {
      message.warning("No hay entradas en el periodo seleccionado");
      return;
    }
    const rows = this.buildExcelRows(entradas);
    const ws = this.jsonToSheetConFechas(rows);
    ws["!cols"] = Object.keys(rows[0]).map((h) => ({
      wch: Math.max(14, h.length + 2),
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Entradas");
    XLSX.writeFile(
      wb,
      `Entradas_NoInventariables_${moment().locale("es").format("L")}.xlsx`
    );
  }

  descargarExcelSalidas() {
    const salidas = this.state.todasInventario.filter((v) => v.salida);
    if (!salidas.length) {
      message.warning("No hay salidas en el periodo seleccionado");
      return;
    }
    const rows = this.buildExcelRows(salidas);
    const ws = this.jsonToSheetConFechas(rows);
    ws["!cols"] = Object.keys(rows[0]).map((h) => ({
      wch: Math.max(14, h.length + 2),
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Salidas");
    XLSX.writeFile(
      wb,
      `Salidas_NoInventariables_${moment().locale("es").format("L")}.xlsx`
    );
  }

  jsonToSheetConFechas(rows) {
    const columnasFecha = ["Fecha", "Caducidad"];
    const ws = XLSX.utils.json_to_sheet(rows, { cellDates: true });
    if (ws["!ref"]) {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      const indicesFecha = [];
      for (let C = range.s.c; C <= range.e.c; C++) {
        const header = ws[XLSX.utils.encode_cell({ r: range.s.r, c: C })];
        if (header && columnasFecha.includes(header.v)) indicesFecha.push(C);
      }
      for (let R = range.s.r + 1; R <= range.e.r; R++) {
        for (const C of indicesFecha) {
          const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell && cell.v instanceof Date) { cell.t = "d"; cell.z = "dd/mm/yyyy"; }
        }
      }
    }
    return ws;
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (v) => (v ? dayjs(v).format("DD/MM/YYYY HH:mm") : "—"),
        sorter: (a, b) =>
          (a.createdAt || "").localeCompare(b.createdAt || ""),
        buscar: "createdAt",
        ellipsis: true,
        width: 130,
      },
      {
        title: "E / S",
        dataIndex: "salida",
        key: "salida",
        render: (_, record) => (record.salida ? "Salida" : "Entrada"),
        ellipsis: true,
        width: 70,
      },
      {
        title: "Folio Mov.",
        dataIndex: "folioMovimientoTipo",
        key: "folioMovimientoTipo",
        sorter: (a, b) =>
          (a.folioMovimientoTipo || "").localeCompare(b.folioMovimientoTipo || ""),
        buscar: "folioMovimientoTipo",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Tipo Doc.",
        dataIndex: "tipoDocumento",
        key: "tipoDocumento",
        sorter: (a, b) =>
          (a.tipoDocumento || "").localeCompare(b.tipoDocumento || ""),
        buscar: "tipoDocumento",
        ellipsis: true,
        width: 110,
      },
      {
        title: "Folio Doc.",
        dataIndex: "folioDocumento",
        key: "folioDocumento",
        sorter: (a, b) =>
          (a.folioDocumento || "").localeCompare(b.folioDocumento || ""),
        buscar: "folioDocumento",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Cód. Proveedor",
        dataIndex: "codigoProveedor",
        key: "codigoProveedor",
        sorter: (a, b) =>
          (a.codigoProveedor || "").localeCompare(b.codigoProveedor || ""),
        buscar: "codigoProveedor",
        ellipsis: true,
        width: 120,
        render: (v) => v ?? "—",
      },
      {
        title: "Cliente / Proveedor",
        dataIndex: "clienteProveedor",
        key: "clienteProveedor",
        sorter: (a, b) =>
          (a.clienteProveedor || "").localeCompare(b.clienteProveedor || ""),
        buscar: "clienteProveedor",
        ellipsis: true,
        width: 180,
      },
      {
        title: "Descripción",
        dataIndex: "descripcionInsumo",
        key: "descripcionInsumo",
        sorter: (a, b) =>
          (a.descripcionInsumo || "").localeCompare(b.descripcionInsumo || ""),
        buscar: "descripcionInsumo",
        ellipsis: true,
        width: 200,
      },
      {
        title: "Familia",
        dataIndex: "nombreFamilia",
        key: "nombreFamilia",
        sorter: (a, b) =>
          (a.nombreFamilia || "").localeCompare(b.nombreFamilia || ""),
        buscar: "nombreFamilia",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Unidad",
        dataIndex: "nombreUnidad",
        key: "nombreUnidad",
        sorter: (a, b) =>
          (a.nombreUnidad || "").localeCompare(b.nombreUnidad || ""),
        buscar: "nombreUnidad",
        ellipsis: true,
        width: 80,
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        sorter: (a, b) => (a.cantidad || 0) - (b.cantidad || 0),
        ellipsis: true,
        width: 80,
        align: "right",
        render: (v) => (v ?? 0).toFixed(2),
      },
      {
        title: "Lote",
        dataIndex: "lote",
        key: "lote",
        sorter: (a, b) => (a.lote || "").localeCompare(b.lote || ""),
        buscar: "lote",
        ellipsis: true,
        width: 100,
        render: (v) => v ?? "—",
      },
      {
        title: "Caducidad",
        dataIndex: "caducidad",
        key: "caducidad",
        sorter: (a, b) => (a.caducidad || "").localeCompare(b.caducidad || ""),
        ellipsis: true,
        width: 100,
        render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "—"),
      },
      {
        title: "Referencia",
        dataIndex: "referencia",
        key: "referencia",
        sorter: (a, b) => (a.referencia || "").localeCompare(b.referencia || ""),
        buscar: "referencia",
        ellipsis: true,
        width: 120,
        render: (v) => v ?? "—",
      },
      {
        title: "Observaciones",
        dataIndex: "observaciones",
        key: "observaciones",
        sorter: (a, b) =>
          (a.observaciones || "").localeCompare(b.observaciones || ""),
        buscar: "observaciones",
        ellipsis: true,
        width: 150,
        render: (v) => v ?? "—",
      },
      {
        title: "Costo Unit.",
        dataIndex: "costoUnitario",
        key: "costoUnitario",
        sorter: (a, b) => (a.costoUnitario || 0) - (b.costoUnitario || 0),
        ellipsis: true,
        width: 100,
        align: "right",
        render: (v) =>
          v != null
            ? Number(v).toLocaleString("es-MX", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "—",
      },
      {
        title: "Costo Total",
        dataIndex: "costoTotal",
        key: "costoTotal",
        sorter: (a, b) => (a.costoTotal || 0) - (b.costoTotal || 0),
        ellipsis: true,
        width: 110,
        align: "right",
        render: (v) =>
          v != null
            ? Number(v).toLocaleString("es-MX", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "—",
      },
      {
        title: "Responsable",
        dataIndex: "nombreUsuario",
        key: "nombreUsuario",
        sorter: (a, b) =>
          (a.nombreUsuario || "").localeCompare(b.nombreUsuario || ""),
        buscar: "nombreUsuario",
        ellipsis: true,
        width: 130,
      },
      {
        title: "Hora Recibido",
        dataIndex: "horaRecibido",
        key: "horaRecibido",
        sorter: (a, b) =>
          (a.horaRecibido || "").localeCompare(b.horaRecibido || ""),
        ellipsis: true,
        width: 130,
        render: (v) => (v ? dayjs(v).format("DD/MM/YYYY HH:mm") : "—"),
      },
    ];

    return (
      <>
        <Form
          name="reporteInsumosNoInventariables"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte de Insumos No Inventariables"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcelEntradas()}
                      icon={<FileExcelOutlined />}
                    >
                      Excel Entradas
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcelSalidas()}
                      icon={<FileExcelOutlined />}
                    >
                      Excel Salidas
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="3" key="3" forceRender tab="Periodo">
                  <FormItem
                    initialValue={[
                      moment().subtract(1, "month"),
                      moment(),
                    ]}
                    name="periodo"
                    required
                    noStyle
                  >
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Ninguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem
                                required
                                margin
                                name="unidadDeNegocioId"
                                noStyle
                              >
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
            <div style={{ height: 10 }}></div>
            <TableItem
              rowKey={(value) =>
                (value.insumoId || "") + (value.folioMovimiento || "") + Math.random()
              }
              columns={columns}
              dataSource={this.state.todasInventario}
              size="small"
              pagination={false}
              scroll={{ x: 2500 }}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ReporteInsumosNoInventariables);
